import * as React from 'react'
import { NonIdealState, INonIdealStateProps } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { IconName } from '@blueprintjs/core/lib/esnext/components/icon/icon'

const NoResults: React.FC<INonIdealStateProps> = ({ ...props }) => {
  const defaultIcon: IconName = IconNames.SEARCH

  const defaultProps: Partial<INonIdealStateProps> = {
    icon: defaultIcon,
    title: 'No results',
    description: 'Try changing some of the filters'
  }
  return <NonIdealState {...defaultProps} {...props} />
}

export default NoResults
